import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 14496 18948"
    {...props}
  >
    <path
      d="M8686 17041v-2335H2382c-792 0-1388-180-1786-540-399-360-596-848-596-1470 0-158 30-317 86-479 60-163 145-335 265-515 116-180 236-355 365-523 124-167 278-372 462-612l6655-8900c433-583 793-1007 1071-1273C9187 133 9521 0 9915 0c1273 0 1907 729 1907 2185v9719h540c643 0 1161 85 1551 261s583 561 583 1153c0 484-158 835-476 1058-321 218-796 330-1431 330h-767v2335c0 643-141 1123-428 1436-283 313-664 471-1140 471-467 0-848-163-1136-484-287-322-432-797-432-1423zm-5399-5137h5399V4602l-5399 7302z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
